import { create } from 'zustand';

interface Props {
  filters: any[];
  searchQuery: string;
  sortKey: string;
  page: number;
  initialized: boolean;
  stateVersion: number;
  setFilters: (filters: any[]) => void;
  setSearchQuery: (query: string) => void;
  setSortKey: (key: string) => void;
  setPage: (page: number) => void;
  setInitialized: (initialized: boolean) => void;
  resetState: (workspaceId?: number) => void;
}

const useCollectionState = create<Props>()((set, get) => ({
  filters: [],
  searchQuery: '',
  sortKey: 'recent',
  page: 1,
  initialized: false,
  stateVersion: 0,

  setFilters: (filters) =>
    set((state) => ({
      filters,
      stateVersion: state.stateVersion + 1,
    })),

  setSearchQuery: (searchQuery) =>
    set((state) => ({
      searchQuery,
      stateVersion: state.stateVersion + 1,
    })),

  setSortKey: (sortKey) =>
    set((state) => ({
      sortKey,
      stateVersion: state.stateVersion + 1,
    })),

  setPage: (page) =>
    set((state) => ({
      page,
      stateVersion: state.stateVersion + 1,
    })),

  setInitialized: (initialized) =>
    set((state) => ({
      initialized,
      stateVersion: state.stateVersion + 1,
    })),

  resetState: () => {
    set({
      searchQuery: '',
      sortKey: 'recent',
      page: 1,
      initialized: false,
      stateVersion: get().stateVersion + 1,
    });
  },
}));

export default useCollectionState;
